module.exports = __webpack_public_path__ + "img/product3.8d19b31c.png";